<template>
  <imgBorderContainer
    title="設計作品"
    class="company-img-border company-detail-work"
  >
    <div class="company-works">
      <a-row :gutter="[10, 10]">
        <a-col
          :xs="12"
          :sm="12"
          :md="8"
          v-for="(item, index) in list"
          :key="index"
        >
          <card :data="item"></card>
        </a-col>
      </a-row>
      <div class="look-more">
        <a :href="`${domain}/${$route.params.id}?${utmSource}`" target="_blank"
          >查看更多作品 ></a
        >
      </div>
    </div>
  </imgBorderContainer>
</template>
<script>
import { primary_site_domain } from "@/config";
import imgBorderContainer from "@/components/imgBorderContainer";
import card from "./card";
import { utmSource } from "@/utils/gen-utm-source";
export default {
  components: { imgBorderContainer, card },
  data() {
    return {
      domain: primary_site_domain,
      utmSource,
      loading: false,
    };
  },
  props: ["list"],
};
</script>
<style lang="less">
@import "~@/assets/styles/var.less";
.company-img-border {
  .img-border-btn {
    font-size: 24px;
    padding: 20px 100px 30px;
    @media (max-width: 768px) {
      font-size: 18px;
      padding: 10px 60px 20px;
    }
  }
}
.company-works {
  padding: 90px 10px 20px;
  @media (max-width: 768px) {
    padding: 60px 4px 6px;
  }
  .look-more {
    text-align: right;
    color: @yellow;
    margin-top: 10px;
    font-size: 18px;
    font-weight: 700;
    padding-right: 4px;
    @media (max-width: 768px) {
      font-size: 12px;
    }
  }
}
</style>